import axios, {AxiosResponse} from "axios";
import {OrderType} from "@/enums";

const PATH = "/v2/customers";

export interface CustomerOrder {
    id: string;
    name: string;
    orderType: OrderType;
    validFrom: string;
    validTo?: string;
    notes?: string;
}

export interface CustomerOrders {
    orders: Array<CustomerOrder>;
}

export default {
    // The customer's inventory orders whose first day lies on or after the given day, ascending by their first day
    findInventoryOrdersStartingFrom (customerId: string, startsFrom: string): Promise<AxiosResponse<CustomerOrders>> {
        return axios.get(`${PATH}/${customerId}/orders`, {params: {startsFrom, orderTypes: OrderType.INV}});
    }
};
